import type { components } from '../../../types/schema';

type ApiV1CastRelationship = components['schemas']['ApiV1CastRelationship'];

export const getChatDirection = (castRelationship: ApiV1CastRelationship | null, name: string) => {
  if (!castRelationship) return 'left';
  if (!name) return 'left';
  if (name === castRelationship?.personAName) return 'left';
  if (name === castRelationship?.personBName) return 'right';
  return 'left';
};
